<div class="row">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-4 m-3 rounded" style="background-color: #A5CD39;">
                <h5>Days Back</h5>
                <div class="row">
                    <div class="col-sm-12" style="padding-left: 20px; background-color: #A5CD39;">
                        <kendo-slider [showButtons]="false"
                                      [title]="sliderTitle"
                                      [min]="1"
                                      [max]="5"
                                      [(ngModel)]="daysBackSliderValue"
                                      (valueChange)="sliderValueChanged()">
                        </kendo-slider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" style="background-color: #A5CD39;">
                        <span>15</span>
                        <span style="margin-left: 35px;">30</span>
                        <span style="margin-left: 35px;">90</span>
                        <span style="margin-left: 30px;">120</span>
                        <span style="margin-left: 28px;">1yr</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <kendo-grid #carrierAnalysisGrid
                            [data]="gridData"
                            [pageSize]="gridState.take"
                            [skip]="gridState.skip"
                            [sort]="gridState.sort"
                            [filter]="gridState.filter"
                            [pageable]="true"
                            [sortable]="true"
                            [filterable]="true"
                            [resizable]="true"
                            [autoSize]="true"
                            (dataStateChange)="dataStateChange($event)">
                    <kendo-grid-column title="Action" width="75">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <button type="button" class="btn btn-sml btn-primary m-1" title="View" tabindex="-1"
                                    (click)="viewMatches(dataItem.carrierLaneID)" *ngIf="hasMatches(dataItem.carrierLaneID)">
                                <i class="fas fa-search"></i>
                            </button>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="revenue" title="Revenue" width="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.revenue | currency}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="loadsProcured" title="Loads Procured" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                Loads
                                <br />
                                Procured
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="lostRevenue" title="Lost Revenue" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                Lost
                                <br />
                                Revenue
                            </div>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.lostRevenue | currency}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="lostLoads" title="Lost Loads" width="100"></kendo-grid-column>
                    <kendo-grid-column field="softOffers" title="Soft Offers" width="100"></kendo-grid-column>
                    <kendo-grid-column field="hardOffers" title="Hard Offers" width="100"></kendo-grid-column>
                    <kendo-grid-column field="oZip3" title="OZip3" width="100"></kendo-grid-column>
                    <kendo-grid-column field="dZip3" title="DZip3" width="100"></kendo-grid-column>
                    <kendo-grid-column field="originDistributionCenter" title="Origin DC" width="150"></kendo-grid-column>
                    <kendo-grid-column field="destinationDistributionCenter" title="Destination DC" width="150"></kendo-grid-column>
                    <kendo-grid-column field="modeAbbr" title="Mode" width="100"></kendo-grid-column>
                    <kendo-grid-column field="trailerTypeAbbr" title="Trailer" width="100"></kendo-grid-column>
                    <kendo-grid-column field="rateIndexDescription" title="Rate Index" width="100"></kendo-grid-column>
                    <kendo-grid-column field="orderMatches" title="Order Matches" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                Order
                                <br />
                                Matches
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="rfqMatches" title="RFQ Matches" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                RFQ
                                <br />
                                Matches
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="quoteMatches" title="Quote Matces" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                Quote
                                <br />
                                Matches
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="averagePay" title="Average Pay" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                Average
                                <br />
                                Pay
                            </div>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.averagePay | currency}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="datAverageRate" title="DAT Avg Rate" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                DAT
                                <br />
                                Avg Rate
                            </div>
                        </ng-template>
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.datAverageRate | currency}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="datContributors" title="DAT Contributors" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                DAT
                                <br />
                                Contributors
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="datMoves" title="DAT Moves" width="100">
                        <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                            <div>
                                DAT
                                <br />
                                Moves
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>

        <div class="row">
            <div [ngClass]="isEdit || isAdd || isAddOffer ? 'col-sm-4' : 'col-sm-12'">
                <h3>Matches/Offer</h3>
                <kendo-grid #carrierAnalysisMatchGrid
                            [data]="matchGridData"
                            [pageSize]="matchGridState.take"
                            [skip]="matchGridState.skip"
                            [sort]="matchGridState.sort"
                            [filter]="matchGridState.filter"
                            [pageable]="true"
                            [sortable]="true"
                            [filterable]="true"
                            [resizable]="true"
                            [autoSize]="false"
                            (dataStateChange)="matchDataStateChange($event)">
                    <kendo-grid-column title="Action" width="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div style="white-space:nowrap;width:100px;">
                                <!--<button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.carrierEquipmentID)"><i class="fas fa-pencil-alt"></i></button>-->
                                <button type="button" class="btn btn-primary" title="Add Offer" (click)="addOffer(dataItem)" *ngIf="canAddOffer(dataItem)">Add Offer</button>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="loadPriority" title="Priority" width="100"></kendo-grid-column>
                    <!--<kendo-grid-column field="quoteOrderLineID" title="Quote #"></kendo-grid-column>-->
                    <kendo-grid-column field="trailer" title="Trailer" width="75"></kendo-grid-column>
                    <!--<kendo-grid-column field="loadType" title="Type"></kendo-grid-column>-->
                    <kendo-grid-column field="mode" title="Mode" width="100"></kendo-grid-column>
                    <kendo-grid-column field="rateIndexDescription" title="Rate Index" width="100"></kendo-grid-column>
                    <kendo-grid-column field="customerName" title="Bill To" width="150"></kendo-grid-column>
                    <kendo-grid-column field="originCity" title="O-City" width="150"></kendo-grid-column>
                    <kendo-grid-column field="originState" title="O-State" width="75"></kendo-grid-column>
                    <kendo-grid-column field="destinationCity" title="D-City" width="150"></kendo-grid-column>
                    <kendo-grid-column field="destinationState" title="D-State" width="75"></kendo-grid-column>
                    <kendo-grid-column field="isRoundTrip" title="RT" width="50">
                        <ng-template kendoGridCellTemplate let-load>
                            <i *ngIf="load.isRoundTrip!=true" class="far fa-square fa-lg text-secondary"></i>
                            <i *ngIf="load.isRoundTrip==true" class="fas fa-check-square fa-lg text-primary"></i>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="earliestDate" title="Earliest" width="100">
                        <ng-template kendoGridCellTemplate let-load>
                            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'HH:mm'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="latestDate" title="Latest" width="100">
                        <ng-template kendoGridCellTemplate let-load>
                            {{load.latestDate == '' ? '' : load.latestDate | date: 'HH:mm'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="startDateTime" title="Start" width="100">
                        <ng-template kendoGridCellTemplate let-load>
                            {{load.startDateTime == '' ? '' : load.startDateTime | date: 'M/dd'}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="orderNumber" title="Order #" width="100">
                        <ng-template kendoGridCellTemplate let-load>
                            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="targetCost" title="Target" format="{0:c}" width="100"></kendo-grid-column>
                    <kendo-grid-column field="maxCarrierPay" title="Max Pay" format="{0:c}" width="100"></kendo-grid-column>
                    <kendo-grid-column field="finalCost" title="Final Cost" format="{0:c}" width="100"></kendo-grid-column>
                    <kendo-grid-column field="erpAssignedTo" title="Tags" width="100"></kendo-grid-column>
                    <kendo-grid-column field="assignedToName" title="Assigned" width="100">
                        <ng-template kendoGridCellTemplate let-load>
                            <!--<a [routerLink]="" (click)="editCarrierReps(load)"><i class="fas fa-pen-square fa-2x text-success"></i></a>-->
                            <!--<button (click)="editCarrierReps(load)" class="btn btn-sml btn-success" title="Edit Assigned Reps"><i class="fas fa-pencil-alt text-white"></i></button>-->
                            {{load.assignedToName}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="accountManagerName" title="Acct Mgr" width="100"></kendo-grid-column>
                    <kendo-grid-column field="repsAssigned" title="Reps" width="75"></kendo-grid-column>
                </kendo-grid>
            </div>

            <!--<div class="col-sm-1" *ngIf="!isEdit && !isAdd">
            <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
        </div>-->

            <div class="col-sm-8" *ngIf="isEdit || isAdd">
                <!-- Edit Customer Action form -->
                <carrier-equipment-form [carrierEquipmentID]="carrierEquipmentID" [carrierID]="carrierID" (onRefresh)="refreshGrid()"></carrier-equipment-form>
            </div>
            <div class="col-sm-8" *ngIf="isAddOffer">
                <h3>Quick Add Offer</h3>
                <!--<div class="row">
                <div class="col">
                    <label class="font-weight-bold">Select Carrier:</label>
                    <carrier-dropdown [parentForm]="carrierFormGroup" [ctrlName]="'carrierLookupControl'" [placeholder]="'Enter Code'"
                                      [carrierLookupType]="'Code'" (carrierSelected)="onCarrierChange($event)"></carrier-dropdown>
                </div>
            </div>-->
                <div class="row" *ngIf="editedCarrierList && (editedCarrierList | json) != '{}'">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-11">
                                <div class="row">
                                    <div class="col">
                                        <label class="font-weight-bold">Order #:</label>
                                        {{searchQuoteOrderLine.quoteOrderID}}
                                    </div>
                                    <div class="col" *ngIf="searchQuoteOrderLine.orderNumber!=searchQuoteOrderLine.quoteOrderID">
                                        <label class="font-weight-bold">Ext #:</label>
                                        {{searchQuoteOrderLine.orderNumber}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">RT:</label>
                                        {{searchQuoteOrderLine.isRoundTrip==true?"Yes":"No"}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Trailer:</label>
                                        {{searchQuoteOrderLine.trailer}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Size:</label>
                                        {{searchQuoteOrderLine.trailerSize > 0 ? searchQuoteOrderLine.trailerSize : ""}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Miles:</label>
                                        {{searchQuoteOrderLine.miles}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Max Pay:</label>
                                        {{searchQuoteOrderLine.maxCarrierPay | currency}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Price:</label>
                                        {{searchQuoteOrderLine.price | currency}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Target:</label>
                                        {{searchQuoteOrderLine.targetCost | currency}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">DAT Rate:</label>
                                        {{searchQuoteOrderLine.spotAverageRate | currency}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-7" *ngIf="false">
                                <div class="row" *ngIf="editedCarrierList">
                                    <div class="col font-weight-bold text-end">Carrier:</div>
                                    <div class="col-sm-2">
                                        <a target="_blank" [routerLink]="['/carrier-detail', editedCarrierList.carrierCode]">
                                            {{editedCarrierList.carrierCode}}
                                        </a><br />
                                        <a target="_blank" [routerLink]="['/carrier-detail', editedCarrierList.carrierCode]">
                                            {{editedCarrierList.carrierName}}
                                        </a><br />
                                        {{editedCarrierList.carrierCity}}, {{editedCarrierList.carrierState}}
                                    </div>
                                    <div class="col-sm-2">
                                        <div *ngIf="editedCarrierList.mcNumber.startsWith('MC')">
                                            <label class="font-weight-bold">MC:</label>
                                            {{editedCarrierList.mcNumber}}
                                        </div>
                                        <div *ngIf="editedCarrierList.dotNumber!=null">
                                            <label class="font-weight-bold">DOT:</label>
                                            {{editedCarrierList.dotNumber}}
                                        </div>
                                        <div *ngIf="editedCarrierList.mcNumber.startsWith('MX')">
                                            <label class="font-weight-bold">MX:</label>
                                            {{editedCarrierList.mcNumber}}
                                        </div>
                                        <div *ngIf="editedCarrierList.scacNumber!=null&&editedCarrierList.scacNumber!=''">
                                            <label class="font-weight-bold">SCAC:</label>
                                            {{editedCarrierList.scacNumber}}
                                        </div>
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Procurements:</label>
                                        {{editedCarrierList.procurements }}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Last Offer:</label>
                                        {{editedCarrierList.lastOfferRate | currency}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Last Rate:</label>
                                        {{editedCarrierList.extendedRate | currency}}
                                    </div>
                                    <div class="col">
                                        <label class="font-weight-bold">Last Date:</label>
                                        {{editedCarrierList.lastRan | date:'shortDate'}}
                                    </div>
                                    <div class="col font-weight-bold text-end">Min Rate:</div>
                                    <div class="col">
                                        {{editedCarrierList.minRate > 0 ? (editedCarrierList.minRate | currency) : ''}}<br />
                                        {{editedCarrierList.minRate > 0 ? (editedCarrierList.minRateDate | date:'shortDate') : ''}}
                                    </div>
                                </div>
                            </div>
                            <!--<div class="col text-end" *ngIf="isBulkTender!=true">
                            <button type="button" (click)="getCarriers();getQuoteOrderLine();" class="btn btn-success">
                                <span class="fas fa-sync" aria-hidden="true"></span> Refresh
                            </button>
                        </div>-->
                        </div>
                        <div class="row" style="margin-bottom:10px;">
                            <div class="col-sm-2">
                                <div class="row">
                                    <div class="col">
                                        <label class="font-weight-bold">Acct Mgr:</label>
                                        {{searchQuoteOrderLine.accountManagerName}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <label class="font-weight-bold">Ops Rep:</label>
                                        {{searchQuoteOrderLine.opsRepName}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <label class="font-weight-bold" style="display: block">Internal Notes</label>
                                <kendo-textarea style="width:100%" id="internalNotes"
                                                resizable="auto"
                                                [(ngModel)]="quoteOrder.internalNotes"
                                                [value]="quoteOrder.internalNotes">
                                </kendo-textarea>
                            </div>
                            <div class="col-sm-3">
                                <label class="font-weight-bold" style="display: block">External Notes</label>
                                <kendo-textarea style="width:100%" id="externalNotes"
                                                resizable="auto"
                                                [(ngModel)]="quoteOrder.externalNotes"
                                                [value]="quoteOrder.externalNotes">
                                </kendo-textarea>
                            </div>
                            <div class="col">
                                <customer-notes [billToID]="searchQuoteOrderLine.billToCustomerID" [shipperID]="searchQuoteOrderLine.shipperCustomerID" [consigneeID]="searchQuoteOrderLine.consigneeCustomerID"></customer-notes>
                            </div>
                            <div class="col-sm-1 text-end align-self-end">
                                <input type="button" class="btn btn-primary" value="Save" (click)="saveQuoteOrderNotes()" />
                                <!--<input type="button" class="btn btn-primary" value="Save" (click)="saveQuoteOrderLineComments()" *ngIf="searchQuoteOrderLine.quoteOrderLineTypeAbbrev!='ORD'&&searchQuoteOrderLine.quoteOrderLineTypeAbbrev!='CG'" />-->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <label class="font-weight-bold" style="display: block">Tags</label>
                                <tagmap-list [isForOrder]="true" [recordID]="searchQuoteOrderLine.quoteOrderID"></tagmap-list>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <!--<carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId"></carrier-geocodelane-detail>-->
                        <carrier-geocodelane-detail [carrierID]="editedCarrierList.carrierId" [carrier]="editedCarrierList"></carrier-geocodelane-detail>
                    </div>
                    <div class="col">
                        <div class="row p-1">
                            <div class="col-sm-3 font-weight-bold text-end">Rate</div>
                            <div class="col">
                                <input #offerRate [(ngModel)]="editedCarrierList.offerRate" (change)="editedCarrierList.offerRatePerMile=calculateOfferRatePerMile(editedCarrierList.offerRate)" name="offerRate" class="form-control k-input" type="number" step="0.01" />
                            </div>
                        </div>
                        <div class="row p-1">
                            <div class="col-sm-3 font-weight-bold text-end">Rate/mi</div>
                            <div class="col">
                                <input [(ngModel)]="editedCarrierList.offerRatePerMile" (change)="editedCarrierList.offerRate=calculateOfferRate(editedCarrierList.offerRatePerMile)" name="offerRatePerMile" class="form-control k-input" type="number" step="0.01" />
                            </div>
                        </div>
                        <div class="row p-1">
                            <div class="col-sm-3 font-weight-bold text-end">Comments</div>
                            <div class="col">
                                <textarea style="width:80%" class="form-control" rows="5" [(ngModel)]="editedCarrierList.commentText"></textarea>
                            </div>
                        </div>
                        <div class="row p-1">
                            <div class="col-sm-3 font-weight-bold text-end">Contact</div>
                            <div class="col">
                                <strong>Emailed:</strong> <input type="checkbox" [checked]="editedCarrierList.emailed" (change)="editedCarrierList.emailed = !editedCarrierList.emailed" /><br />
                                <strong>Declined:</strong> <input type="checkbox" [checked]="editedCarrierList.declined" (change)="editedCarrierList.declined = !editedCarrierList.declined" /><br />
                                <strong>Contacted:</strong> <input type="checkbox" [checked]="editedCarrierList.contacted||editedCarrierList.offerRate>0||editedCarrierList.offerRatePerMile>0" (change)="editedCarrierList.contacted = !editedCarrierList.contacted" /><br />
                                <!--<strong>Preferred:</strong> <input type="checkbox" [checked]="editedCarrierList.preferred" (change)="editedCarrierList.preferred = !editedCarrierList.preferred" />-->
                            </div>
                        </div>
                        <div class="row p-1">
                            <div class="col text-end">
                                <button class="btn btn-primary" (click)="saveOffer(true)" [disabled]="isSaving==true" *ngIf="isCustomerExcluded!=true">Save and Award Offer</button>
                                <button class="btn btn-primary m-1" (click)="saveOffer(false)" [disabled]="isSaving==true" *ngIf="isCustomerExcluded!=true">Save and Continue Sales</button>
                                <button class="btn btn-secondary" (click)="cancelOffer()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="offerID>0 && isAwardOffer">
            <div class="col-sm-12">
                <h4>Tender Load - Order # {{quoteOrderID}}</h4>
                <carrier-offer-form [viewType]="'orderentry'" [pageType]="'Carrier Analysis'" [offerID]="offerID" (onSaveClick)="getQuoteOrder(quoteOrderID)" (onCancelClick)="resetAwardOffer()">
                </carrier-offer-form>
            </div>
        </div>
    </div>
</div>

<!--<record-lock-modal *ngIf="recordLockAction != '' && recordID > 0"
                   [recordID]="recordID"
                   [recordTypeName]="'QuoteOrder'"
                   [lockSource]="'Carrier Analysis'"
                   (cancelOverride)="cancelEdit()">
</record-lock-modal>-->
